var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllFurnitureIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.50586,
    width: 37.0448,
    height: 4.37994,
    rx: 2.18997,
    fill: "#33332B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.50586,
    y: 13.3719,
    width: 37.0448,
    height: 4.37994,
    rx: 2.18997,
    fill: "#33332B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.50586,
    y: 27.6201,
    width: 37.0448,
    height: 4.37994,
    rx: 2.18997,
    fill: "#33332B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.37994,
    height: 4.37994,
    rx: 2.18997,
    fill: "#33332B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 13.3719,
    width: 4.37994,
    height: 4.37994,
    rx: 2.18997,
    fill: "#33332B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 27.6201,
    width: 4.37994,
    height: 4.37994,
    rx: 2.18997,
    fill: "#33332B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllFurnitureIcon);
export default __webpack_public_path__ + "static/media/all-furniture-icon.9e213c681a78f34f1657565089a848e2.svg";
export { ForwardRef as ReactComponent };